import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function friendNameValidator(control: FormGroup): ValidationErrors | null {
    const comingWithFriend = control.value.isComingWithFriends;
    const friend = control.value.friendName;

    return comingWithFriend && !friend ? { "friendNameMissing": true } : null;
}